/*eslint no-lone-blocks: "error"*/
import React, { Suspense, useContext } from 'react';
import { Switch, RouteComponentProps } from 'react-router-dom';
import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';
import FilesHistoryProvider from 'context/files-history';
import UserRoleContext from 'context/user-role/context';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import useBreadcrumbs from 'hooks/useBreadcrumbs';
import routes from './routes';

const FilesContainer = ({ history }: RouteComponentProps) => {
  const { getAccessByMenu } = useContext(UserRoleContext);
  useBreadcrumbs(history, routes);
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <FilesHistoryProvider>
        <Switch>
          {routes.map((route, i) => {

            return (
              getAccessByMenu(route) && (
                <RouteWithSubRoutes key={`${i}_${route.path}`} {...route} />
              )
            );
          })}
        </Switch>
      </FilesHistoryProvider>
    </Suspense>
  );
};

export default FilesContainer;
